import React from 'react'

export const Footer = () => {
    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 footer-copyright text-center">
                        <p className="mb-0">Copyright 2026 © Amy Technologies  </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}
